//################################################################################### LOGIN ###################################################################################
import {Login} from './other/Login';
import {Logout} from './other/Logout';



//################################################################################### REGIME ###################################################################################
import {ListRegime} from './list/ListRegime';


//################################################################################### SENHA ###################################################################################
import {AlterSenha} from './alter/AlterSenha';


//################################################################################### EMPRESA ###################################################################################
import {AddEmpresa} from './insert/AddEmpresa';


//################################################################################### UNIDADE ###################################################################################
import {ListUnidade} from './list/ListUnidade';
import {AddUnidade} from './insert/AddUnidade';
import {AlterarUnidade} from './alter/AlterarUnidade';
import {DeleteUnidade} from './delete/DeleteUnidade';

//################################################################################### FAMILIA ###################################################################################
import {ListFamilia} from './list/ListFamilia';
import {AddFamilia} from './insert/AddFamilia';
import {AlterFamilia} from './alter/AlterFamilia';
import {DeleteFamilia} from './delete/DeleteFamilia';

//################################################################################### ARMAZEM ###################################################################################
import {ListArmazem} from './list/ListArmazem';
import {AddArmazem} from './insert/AddArmazem';
import {AlterArmazem} from './alter/AlterArmazem';
import {DeleteArmazem} from './delete/DeleteArmazem';


//################################################################################### F PAGAMENTO ###################################################################################
import {ListFPagamento} from './list/ListFPagamento';
import {AddFPagamento} from './insert/AddFPagamento';
import {AlterFpagamento} from './alter/AlterFpagamento';
import {DeleteFPagamento} from './delete/DeleteFPagamento';


//################################################################################### BANCO ###################################################################################
import {ListBanco} from './list/ListBanco';
import {AddBanco} from './insert/AddBanco';
import {AlterBanco} from './alter/AlterBanco';
import {DeleteBanco} from './delete/DeleteBanco';




//################################################################################### VEICULO ###################################################################################
import {ListVeiculo} from './list/ListVeiculo';
import {AddVeiculo} from './insert/AddVeiculo';
import {AlterVeiculo} from './alter/AlterVeiculo';
import {DeleteVeiculo} from './delete/DeleteVeiculo';


//################################################################################### CONTA ###################################################################################
import {ListConta} from './list/ListConta';
import {AddConta} from './insert/AddConta';
import {AlterConta} from './alter/AlterConta';
import {DeleteConta} from './delete/DeleteConta';



//################################################################################### FORMA PAGAMENTO ###################################################################################
import {ListFormaPagamento} from './list/ListFormaPagamento';
import {AddFormaPagamento} from './insert/AddFormaPagamento';
import {AlterFormaPagamento} from './alter/AlterFormaPagamento';
import {DeleteFormaPagamento} from './delete/DeleteFormaPagamento';


//################################################################################### IMPOSTO ###################################################################################
import {ListImposto} from './list/ListImposto';
import {AddImposto} from './insert/AddImposto';
import {AlterImposto} from './alter/AlterImposto';
import {DeleteImposto} from './delete/DeleteImposto';
import {ListImpostoid} from './list/ListImpostoid';

//################################################################################### MOEDA ###################################################################################
import {ListMoeda} from './list/ListMoeda';
import {ListMoedaCambio} from './list/ListMoedaCambio';
import {AddMoeda} from './insert/AddMoeda';
import {AlterMoeda} from './alter/AlterMoeda';
import {DeleteMoeda} from './delete/DeleteMoeda';



//################################################################################### CAMBIO ###################################################################################
import {ListCambio} from './list/ListCambio';
import {AddCambio} from './insert/AddCambio';
import {AlterCambio} from './alter/AlterCambio';
import {DeleteCambio} from './delete/DeleteCambio';


//################################################################################### PRODUTO ###################################################################################
import {ListProduto} from './list/ListProduto';
import {AddProduto} from './insert/AddProduto';
import {AlterProduto} from './alter/AlterProduto';
import {DeleteProduto} from './delete/DeleteProduto';

//################################################################################### ISENÇÃO ###################################################################################
import {ListIsencao} from './list/ListIsencao';

//################################################################################### EMPRESA ###################################################################################
import {ListEmpresa} from './list/ListEmpresa';

//################################################################################### SERVIÇO ###################################################################################
import {ListServico} from './list/ListServico';
import {AddServico} from './insert/AddServico';
import {AlterServico} from './alter/AlterServico';
import {DeleteServico} from './delete/DeleteServico';


//################################################################################### CLIENTE ###################################################################################
import {ListCliente} from './list/ListCliente';
import {ListClienteInativo} from './list/ListClienteInativo';
import {AddCliente} from './insert/AddCliente';
import {AlterCliente} from './alter/AlterCliente';
import {AlterStatusCliente} from './alter/AlterStatusCliente';
import {DeleteCliente} from './delete/DeleteCliente';



//################################################################################### NACIONALIDADE ###################################################################################
import {ListNacionalidade} from './list/ListNacionalidade';


//################################################################################### FORNECEDOR ###################################################################################
import {ListFornecedor} from './list/ListFornecedor';
import {ListFornecedorInativo} from './list/ListFornecedorInativo';
import {AddFornecedor} from './insert/AddFornecedor';
import {AlterFornecedor} from './alter/AlterFornecedor';
import {AlterStatusFornecedor} from './alter/AlterStatusFornecedor';
import {DeleteFornecedor} from './delete/DeleteFornecedor';


//################################################################################### PERFIL ###################################################################################
import {ListPerfil} from './list/ListPerfil';


//################################################################################### USUÁRIO ###################################################################################
import {AddUsuario} from './insert/AddUsuario';
import {DeleteUser} from './delete/DeleteUser';
import {ListUser} from './list/ListUser';
import {ListUserInativo} from './list/ListUserInativo';
import {AlterUser} from './alter/AlterUser';



//################################################################################### PROCESSO ###################################################################################
import {ListEstoque} from './list/ListEstoque';
import {AddProcessoEntradaEstoque} from './insert/AddProcessoEntradaEstoque';
import {DeleteProcesso} from './delete/DeleteProcesso';
import {ListCompraFornecedor} from './list/ListCompraFornecedor';
import {AddProcessoCompraFornecedor} from './insert/AddProcessoCompraFornecedor';
import {AddInventario} from './insert/AddInventario';
import {AddProcessoInventario} from './insert/AddProcessoInventario';
import {ListInventario} from './list/ListInventario';
 



//################################################################################### DOCUMENTO ###################################################################################
import {AddEntradaEstoque} from './insert/AddEntradaEstoque';
import {AddCompraFornecedor} from './insert/AddCompraFornecedor';


//################################################################################### TURNO ###################################################################################
import {ListTurno} from './list/ListTurno';
import {AbrirTurno} from './insert/AbrirTurno';
import {FecharTurno} from './alter/FecharTurno';
import {ListTurnoFechado} from './list/ListTurnoFechado';




const Api={
ListIsencao,
ListEmpresa,
ListRegime,
AlterSenha,
AddEmpresa,
Login,
ListUnidade,
AddUnidade,
AlterarUnidade,
DeleteUnidade,
ListFamilia,
AddFamilia,
AlterFamilia,
DeleteFamilia,
ListArmazem,
AddArmazem,
AlterArmazem,
DeleteArmazem,
ListFPagamento,
AddFPagamento,
AlterFpagamento,
DeleteFPagamento,
ListBanco,
AddBanco,
AlterBanco,
DeleteBanco,
DeleteVeiculo,
AlterVeiculo,
AddVeiculo,
ListVeiculo,
ListConta,
AddConta,
AlterConta,
DeleteConta,
ListFormaPagamento,
AddFormaPagamento,
AlterFormaPagamento,
DeleteFormaPagamento,
ListImposto,
ListImpostoid,
AddImposto,
AlterImposto,
DeleteImposto,
ListMoeda,
AddMoeda,
AlterMoeda,
DeleteMoeda,
ListMoedaCambio,
ListCambio,
AddCambio,
AlterCambio,
DeleteCambio,
ListProduto,
AddProduto,
AlterProduto,
DeleteProduto,
ListServico,
AddServico,
AlterServico,
DeleteServico,
ListCliente,
AddCliente,
AlterCliente,
DeleteCliente,
ListClienteInativo,
ListNacionalidade,
AlterStatusCliente,
ListFornecedor,
ListFornecedorInativo,
AddFornecedor,
AlterFornecedor,
AlterStatusFornecedor,
DeleteFornecedor,
Logout,
ListPerfil,
AddUsuario,
ListUser,
DeleteUser,
ListUserInativo,
AlterUser,
ListEstoque,
AddProcessoEntradaEstoque,
AddEntradaEstoque,
DeleteProcesso,
FecharTurno,
AbrirTurno,
ListTurno,
ListTurnoFechado,
ListCompraFornecedor,
AddProcessoCompraFornecedor,
AddCompraFornecedor,
ListInventario,
AddProcessoInventario,
AddInventario,




}

export default Api;